var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLolipop2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 16.1667C15.3155 16.7335 14.8112 17.244 14.25 17.6853V22C14.25 22.4142 14.5858 22.75 15 22.75C15.4142 22.75 15.75 22.4142 15.75 22V16.1667Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5712 2.89583C12.5846 2.3254 13.7543 2 15 2C18.866 2 22 5.13401 22 9C22 12.555 19.35 15.491 15.9176 15.9404C16.9138 14.5481 17.5 12.8425 17.5 11C17.5 7.20182 15.0088 3.98549 11.5712 2.89583Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 17.9603C13.2633 17.5861 16 14.6126 16 11C16 7.13401 12.866 4 9 4C5.13401 4 2 7.13401 2 11C2 14.6126 4.73668 17.5861 8.25 17.9603V22C8.25 22.4142 8.58579 22.75 9 22.75C9.41421 22.75 9.75 22.4142 9.75 22V17.9603ZM8.25 7C8.25 6.58579 8.58579 6.25 9 6.25C11.6234 6.25 13.75 8.37665 13.75 11C13.75 11.4142 13.4142 11.75 13 11.75C12.5858 11.75 12.25 11.4142 12.25 11C12.25 9.20507 10.7949 7.75 9 7.75C8.58579 7.75 8.25 7.41421 8.25 7Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLolipop2);
export default __webpack_public_path__ + "static/media/lolipop-2.79c5dbc3d85013fe9d038dd2b251d844.svg";
export { ForwardRef as ReactComponent };